import React from 'preact/compat'

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Label from './Label';
import colors from '../colors';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const DropDownSelector = ({id, label, options, value, setValue, description}) => {
    const handleChange = (e) => {
        setValue(e.target.value);
    }

    return (
    <FormControl>
        <Label id={id} label={label} description={description} />
        <Select
            aria-labelledby={id + "-label"}
            id={id}
            name={id}
            value={value}
            onChange={handleChange}
            IconComponent={ExpandMoreIcon}
            sx={{
                borderRadius: '4px',
                width: '256px',
                height: '40px',
                backgroundColor: colors.inputBackground,
                borderColor: colors.inputBorder,
                borderSize: '1px',
                fontSize: '16px',
                fontWeight: 400,
                color: colors.inputText,
                paddingLeft: 0,
                '& .MuiSelect-select': {
                    marginTop: '2px'
                },
                '&.Mui-focused > .MuiOutlinedInput-notchedOutline, &:hover > .MuiOutlinedInput-notchedOutline': {
                    borderColor: colors.option
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    inset: 0,
                    '& legend': {
                        display: 'none'
                    }
                }
            }}
            MenuProps={{
                sx: {
                    width: '256px',
                    borderRadiusTopLeft: 0,
                    borderRadiusTopRight: 0,
                    '& .MuiList-root': {
                        backgroundColor: colors.inputBackground,
                        borderColor: colors.inputBorder,
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderRadius: '4px',
                        paddingTop: 0,
                        paddingBottom: 0
                    },
                    '& .MuiMenuItem-root': {
                        height: '40px',
                        fontWeight: 400,
                        color: colors.inputText,
                        '&.hidden': {
                            display: 'none'
                        },
                        '&:hover, &.Mui-selected': {
                            backgroundColor: colors.inputBorder
                        }
                    }
                }
            }}
        >
            {options.map(v =>
                <MenuItem key={v.value} value={v.value} >
                    {v.label}
                </MenuItem>
            )}
        </Select>
    </FormControl>);
};

export default DropDownSelector;
